import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { SchedulePay } from 'components/Shared/Icons/Icons';
import { breakpoints, colors } from 'styles/cp';

export interface Props {
  errorType: 'canceled' | 'general';
  companyName: string;
}

const SubscriptionError: React.FC<Props> = ({ errorType, companyName }) => {
  const { title, p } = {
    canceled: {
      title: {
        id: 'LOOKS_LIKE_SUBSCRIPTION_CANCELED',
        default: `Looks like ${companyName} cancelled this recurring payment.`,
      },
      p: {
        id: 'IF_MISTAKE_REACH_OUT_TO',
        default: `Think this is a mistake? Reach out to ${companyName} for more info.`,
      },
    },
    general: {
      title: {
        id: 'LOOKS_LIKE_SUBSCRIPTION_NOT_ACTIVE',
        default: `Looks like this recurring payment is no longer active.`,
      },
      p: {
        id: 'IF_INFO_REACH_OUT_TO',
        default: `Need more info? Reach out to ${companyName}.`,
      },
    },
  }[errorType];

  return (
    <Fragment>
      <div className="sub-error-wrapper">
        <span className="title-wrapper">
          <SchedulePay width={20} height={20} color={colors.warn} />
          <span className="title">
            <FormattedMessage
              id={title.id}
              defaultMessage={title.default}
              values={{ companyName }}
            />
          </span>
        </span>
        <p className="p">
          <FormattedMessage id={p.id} defaultMessage={p.default} values={{ companyName }} />
        </p>
      </div>
      <style jsx>{`
        .sub-error-wrapper {
          padding: 15px 66px 0;
          min-height: 160px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          @media screen and (max-width: ${breakpoints.md}) {
            padding: 15px 15px 0;
            justify-content: flex-start;
          }
          color: ${colors.gray};
          .title-wrapper {
            display: grid;
            grid-template-columns: 20px 1fr;
            .title {
              font-family: AvenirNextforINTUIT-Bold;
              line-height: 24px;
              margin-left: 8px;
            }
          }
          .p {
            font-size: 14px;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default SubscriptionError;
